import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { getAdditionalUserInfo, getAuth } from "firebase/auth";

const Redirect = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    getAuth().onAuthStateChanged((result) => {
      if (window.location.pathname !== "/") return;
      if (!result) navigate("/login");
     if (result) {
       result.getIdTokenResult().then((idTokenResult) => {
         //checking if the user is super admin
         if (idTokenResult.claims.admin) {
           navigate("/user/admin/dashboard");
         } else {
           navigate("/user/dashboard");
         }
       });
     } else navigate("/login");
    });
  }, []);
  // useEffect(() => {
  //   getAuth().onAuthStateChanged((result) => {
  //     if (window.location.pathname !== "/") return;
  //     if (!result) navigate("/login", { replace: true });
  //     if (result) navigate("/user/dashboard", { replace: true });
  //     else navigate("/login", { replace: true });
  //   });
  // }, []);

  return (
    <div id="preloader">
      <div className="sk-three-bounce">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(Redirect);
